import request from '@/utils/request'

//查询指定试卷
export function SelectPointQuestion(params) {
    return request({
        url: '/api/ExamQuestion/Load',
        method: 'get',
        params
    })
}

//添加试卷
export function AddPaper(data) {
    return request({
        url: '/api/Exam/Add',
        method: 'post',
        data
    })
}

//添加试卷题目
export function AddPaperQuestion(data) {
    return request({
        url: '/api/Exam/AddPaperQuestion',
        method: 'post',
        data
    })
}

//查询试卷详情
export function SelectDetailsPaper(params) {
    return request({
        url: '/api/Exam/Get',
        method: 'get',
        params
    })
}

//查询试卷题目详情
export function SelectPaperQuestion(params) {
    return request({
        url: '/api/Exam/GetOfficialMan',
        method: 'get',
        params
    })
}


// 
export function GetDetail(params) {
    return request({
        url: '/api/Exam/GetDetail',
        method: 'get',
        params
    })
}

//修改试卷
export function UpdatePaper(data) {
    return request({
        url: '/api/Exam/Update',
        method: 'post',
        data
    })
}

//修改试卷题目
export function UpdatePaperQuestion(data) {
    return request({
        url: '/api/Exam/UpdatePaperQuestion',
        method: 'post',
        data
    })
}

// 获取自动试题列表
export function GetAutoQuestionList(data) {
    return request({
        url: '/api/Exam/AutoQuestionList',
        method: 'post',
        data
    })
}